import { Alert, AlertTitle, Typography } from '@mui/material';
import type { ReactNode } from 'react';
import { useAuth } from '@/lib/auth/AuthContext';
import { can, type Permission } from '@/lib/auth/permissions';
import { LoadingState } from './states';
import { LoginPage } from './LoginPage';

/**
 * Bramka WIDOCZNOŚCI. Nie jest zabezpieczeniem — patrz nagłówek permissions.ts.
 * Backend musi odrzucić żądanie niezależnie od tego, co pokaże ten komponent.
 */
export function RequirePermission({
  permissions,
  children,
}: {
  permissions?: readonly Permission[];
  children: ReactNode;
}) {
  const auth = useAuth();

  if (auth.status === 'unknown') return <LoadingState label="Sprawdzanie sesji…" />;
  if (auth.status === 'anonymous') return <LoginPage />;

  if (!can(auth.permissions, permissions)) {
    return (
      <Alert severity="warning" role="alert">
        <AlertTitle>Brak uprawnień</AlertTitle>
        <Typography variant="body2">
          Podłączone konta nie mają uprawnień wymaganych przez ten ekran
          {permissions?.length ? ` (${permissions.join(', ')})` : ''}.
        </Typography>
        <Typography variant="caption" color="text.secondary" component="p" sx={{ mt: 1 }}>
          Część danych wymaga osobnego logowania do systemu, z którego pochodzą. To jest widoczny
          skutek braku zunifikowanej tożsamości, nie awaria.
        </Typography>
      </Alert>
    );
  }

  return <>{children}</>;
}
